module.exports = __webpack_public_path__ + "img/report2-3.55fad5cd.jpg";